import { jsx as _jsx } from "react/jsx-runtime";
import { BlogArticle, BlogIndex } from './pages/Blog/BlogPages';
import { blogPath, POSTS } from './pages/Blog/posts';
import DealerWebsitesPage from './pages/Marketing/DealerWebsitesPage';
import FaqPage from './pages/Marketing/FaqPage';
import ForDealersPage from './pages/Marketing/ForDealersPage';
import GuidePage from './pages/Marketing/GuidePage';
import HomePage from './pages/Marketing/HomePage';
import ImportMyOwnPage from './pages/Marketing/ImportMyOwnPage';
import PricingPage from './pages/Marketing/PricingPage';
import ProductBiddingPage from './pages/Marketing/ProductBiddingPage';
import ProductEmailPage from './pages/Marketing/ProductEmailPage';
import ProductHuntsPage from './pages/Marketing/ProductHuntsPage';
import ProductLandedCostPage from './pages/Marketing/ProductLandedCostPage';
import ProductPricingGuidancePage from './pages/Marketing/ProductPricingGuidancePage';
import ProductSearchPage from './pages/Marketing/ProductSearchPage';
import ProductSheetsPage from './pages/Marketing/ProductSheetsPage';
import RequestAccessPage from './pages/Marketing/RequestAccessPage';
import SecurityPage from './pages/Marketing/SecurityPage';
import TermsPage from './pages/Marketing/TermsPage';
import { TERMS_VERSION } from './pages/Marketing/terms';
/**
 * The public marketing pages. The router mounts these, and the production build prerenders
 * each one to static HTML (scripts/prerender.mjs), so a page added here is crawlable and has
 * link previews with no other change. Keep this file free of signed-in app imports: it is the
 * whole of the server render bundle.
 */ export const MARKETING_PAGES = [
    {
        path: '/',
        element: /*#__PURE__*/ _jsx(HomePage, {}),
        title: 'Right Hand DMS · JDM import software for dealers and individuals',
        description: 'JDM import software for dealerships and for people importing their own car. Search the auctions, read sheets in English, clear customs and track landed cost.',
        keyphrase: 'JDM import software',
        crumb: 'Home',
        modified: '2026-10-25',
        schema: 'software'
    },
    {
        path: '/for-dealers',
        element: /*#__PURE__*/ _jsx(ForDealersPage, {}),
        title: 'JDM import software for dealerships · Right Hand DMS',
        description: 'For JDM import dealerships. Run a hunt per customer through your own exporter accounts, bid from sold lots, handle customs per shipment and see profit per car.',
        keyphrase: 'JDM import dealerships',
        crumb: 'For dealers',
        modified: '2026-10-25'
    },
    {
        path: '/dealer-websites',
        element: /*#__PURE__*/ _jsx(DealerWebsitesPage, {}),
        title: 'Dealer websites for JDM import dealers · Right Hand DMS',
        description: 'Dealer websites for JDM import dealers: five themes we host on WordPress, synced both ways with your inventory, with deposits through your own Square account.',
        keyphrase: 'dealer websites',
        crumb: 'Dealer websites',
        modified: '2026-11-03'
    },
    {
        path: '/import-my-own',
        element: /*#__PURE__*/ _jsx(ImportMyOwnPage, {}),
        title: 'Import your own JDM car from Japan · Right Hand DMS',
        description: 'Import your own JDM car or truck from Japan. A first-timer gets each step in order: the exporter account, auction grades, bids, a customs broker, the trip home.',
        keyphrase: 'import own JDM car Japan',
        crumb: 'Import my own',
        modified: '2026-10-25'
    },
    {
        path: '/guide',
        element: /*#__PURE__*/ _jsx(GuidePage, {}),
        title: 'How to import a car from Japanese auctions · Right Hand DMS',
        description: 'How importing a car from a Japanese auction goes, in order. The 25-year rule, export agents, freight and duty, customs brokers, and a title in your state.',
        keyphrase: 'import car Japanese auction',
        crumb: 'Importing guide',
        modified: '2026-10-25',
        schema: 'article'
    },
    {
        path: '/pricing',
        element: /*#__PURE__*/ _jsx(PricingPage, {}),
        title: 'Pricing and plans for JDM import shops · Right Hand DMS',
        description: 'JDM import shops pay monthly, on plans priced by the auction sheets you read. Bringing in your own car? Import my own is a one-time sign-up instead.',
        keyphrase: 'JDM import shop plans',
        crumb: 'Pricing',
        modified: '2026-10-25',
        schema: 'software'
    },
    {
        path: '/faq',
        element: /*#__PURE__*/ _jsx(FaqPage, {}),
        title: 'JDM import shop questions, answered · Right Hand DMS',
        description: 'The questions JDM import shops ask us about Right Hand DMS. Auction agents and logins, auction sheets, landed cost, your own email, security and the invite.',
        keyphrase: 'JDM import shop questions',
        crumb: 'FAQ',
        modified: '2026-10-25',
        schema: 'faq'
    },
    {
        path: '/security',
        element: /*#__PURE__*/ _jsx(SecurityPage, {}),
        title: 'Security and privacy for your shop’s data · Right Hand DMS',
        description: 'Security and privacy for your shop’s data: encrypted auction logins and mailbox tokens, isolated accounts, email that starts as a draft, and what AI reads.',
        keyphrase: 'shop data security privacy',
        crumb: 'Security',
        modified: '2026-10-25'
    },
    {
        path: '/terms',
        element: /*#__PURE__*/ _jsx(TermsPage, {}),
        title: 'Terms of Service for shops and importers · Right Hand DMS',
        description: 'The Terms of Service for Right Hand DMS: accounts, plans and car passes billed through Stripe, the Import my own sign-up guarantee, and the records we keep.',
        keyphrase: 'terms of service',
        crumb: 'Terms',
        modified: TERMS_VERSION
    },
    {
        path: '/request-access',
        element: /*#__PURE__*/ _jsx(RequestAccessPage, {}),
        title: 'Request access for dealers and importers · Right Hand DMS',
        description: 'Request access to Right Hand DMS as a JDM import dealership or as someone importing their own car. We’ll set up your account, or a short call with you first.',
        keyphrase: 'request access import',
        crumb: 'Request access',
        modified: '2026-10-25',
        schema: 'contact'
    },
    {
        path: '/product/search',
        element: /*#__PURE__*/ _jsx(ProductSearchPage, {}),
        title: 'Search Japanese car auctions across agents · Right Hand DMS',
        description: 'Search Japanese car auctions once, across your JapanCarDirect, JDM Auc and Pacific Coast JDM agent accounts. Save it as a hunt to hear about new matches.',
        keyphrase: 'search Japanese car auctions',
        crumb: 'Auction search',
        modified: '2026-10-25'
    },
    {
        path: '/product/auction-sheets',
        element: /*#__PURE__*/ _jsx(ProductSheetsPage, {}),
        title: 'Japanese auction sheet translation · Right Hand DMS',
        description: 'Japanese auction sheet translation that sits beside the original. Grades, mileage, damage, options, inspector notes and the full frame number, in plain English.',
        keyphrase: 'Japanese auction sheet translation',
        crumb: 'Auction sheets',
        modified: '2026-10-25'
    },
    {
        path: '/product/pricing-guidance',
        element: /*#__PURE__*/ _jsx(ProductPricingGuidancePage, {}),
        title: 'JDM auction price estimates from sold lots · Right Hand DMS',
        description: 'JDM auction price estimates built from what similar cars sold for. Each estimate lists the sold lots behind its bid range, so you can check the numbers.',
        keyphrase: 'JDM auction price estimates',
        crumb: 'Pricing guidance',
        modified: '2026-10-25'
    },
    {
        path: '/product/hunts',
        element: /*#__PURE__*/ _jsx(ProductHuntsPage, {}),
        title: 'Hunts: automated JDM custom orders · Right Hand DMS',
        description: 'A hunt is a standing auction search for JDM custom orders. It reads the sheets, prices the matches, chases any missing sheet and drafts the customer shortlist.',
        keyphrase: 'JDM custom orders',
        crumb: 'Hunts',
        modified: '2026-10-25'
    },
    {
        path: '/product/bidding',
        element: /*#__PURE__*/ _jsx(ProductBiddingPage, {}),
        title: 'Auction bid tracking from watchlist to sold · Right Hand DMS',
        description: 'Every auction lot you act on becomes one car record. Bids are tracked from the watchlist through import to sold, and the sheet and photos stay with the car.',
        keyphrase: 'auction bids watchlist',
        crumb: 'Bidding & wins',
        modified: '2026-10-25'
    },
    {
        path: '/product/landed-cost',
        element: /*#__PURE__*/ _jsx(ProductLandedCostPage, {}),
        title: 'Landed cost for every imported car · Right Hand DMS',
        description: 'The real landed cost of every imported car, line by line from your paperwork. Auction, agent fees, freight, duty, the customs broker and prep, then profit.',
        keyphrase: 'imported car landed cost',
        crumb: 'Landed cost',
        modified: '2026-10-25'
    },
    {
        path: '/product/email',
        element: /*#__PURE__*/ _jsx(ProductEmailPage, {}),
        title: 'Customer and agent email from your mailbox · Right Hand DMS',
        description: 'Customer email from your own mailbox, over Fastmail or IMAP. Sheet requests reach your agent from your address, and customer email waits as a draft for your OK.',
        keyphrase: 'customer email mailbox',
        crumb: 'Email',
        modified: '2026-10-25'
    },
    {
        path: '/blog',
        element: /*#__PURE__*/ _jsx(BlogIndex, {}),
        title: 'Blog: importing JDM cars from Japan · Right Hand DMS',
        description: 'The Right Hand DMS blog, on importing JDM cars from Japan. How to read auction sheets and grades, the 25-year rule, export agents, kei trucks and landed cost.',
        keyphrase: 'importing JDM cars blog',
        crumb: 'Blog',
        modified: POSTS[0].modified,
        schema: 'blog'
    },
    ...POSTS.map((p)=>({
            path: blogPath(p.slug),
            element: /*#__PURE__*/ _jsx(BlogArticle, {
                post: p
            }),
            title: p.title,
            description: p.description,
            keyphrase: p.keyphrase,
            crumb: p.topic,
            modified: p.modified,
            published: p.published,
            schema: 'post'
        }))
];
/**
 * Router entries for the marketing pages, shared by the browser router and the prerender. The
 * handle names the tab after client-side navigation (lib/pageTitle.tsx); the prerender writes
 * the same title into each page's HTML.
 */ export const marketingRoutes = MARKETING_PAGES.map((page)=>({
        path: page.path,
        element: page.element,
        handle: {
            title: page.title,
            full: true
        }
    }));
